module.exports = "/_next/static/images/status-ok-7a7b5167.png";